type Args = {
	key: string;
	shiftKey: boolean;
	isComposing: boolean;
	isTouchDevice: boolean;
};

export const shouldSubmitOnEnter = ({
	key,
	shiftKey,
	isComposing,
	isTouchDevice,
}: Args) => key === "Enter" && !shiftKey && !isComposing && !isTouchDevice;
